export default __webpack_public_path__ + "static/media/agentHome.3665968b.png";